import "../css/login.css";
import React, {useState} from "react";
import { useLanguage } from "../components/Language.js";
import {BASE_URL} from "../constants"

function LoginForm({onLogin, onClose}){
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const {language} = useLanguage();

    const translations = {
        en: {
            loginInfo: "Log in to check in and add events!",
            emailPlaceholder: "Enter your email",
            passwordPlaceholder: "Enter your password",
            loginButton: "Log In",
            cancelButton: "Cancel",
        },
        gd: {
            loginInfo: "log a-steach gus clàradh a-steach agus cuir tachartasan ris",
            emailPlaceholder: "Cuir a-steach am post-d agad",
            passwordPlaceholder: "Cuir a-steach am facal-faire agad",
            loginButton: "Log a-steach",
            cancelButton: "Sguir dheth",
        },
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const response = await fetch(`${BASE_URL}/api/login/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({email, password}),
        });

        const result = await response.json();

        if(result["status"] !== "failed"){
            console.log("Log in success");
            console.log(result.userData.username);

            onLogin(result.userData.username, result.userData.e_mail, 
                result.userData.first_name, result.userData.last_name, result.userData.about,
                result.userData.postcode, result.userData.consent, result.userData.gender,
                result.userData.inital_lang, result.userData.current_lang, 
                result.userData.tourist, result.userData.profile_picture,
                result.userData.age_range, result.userData.labels, result.userData.admin, 
                result.userData.locations,result.userData.level, result.cookie);
        }
        else{
            console.log("Login failed");
            let errorDiv = document.getElementById("login-error");
            errorDiv.innerHTML = ''
            errorDiv.innerHTML = result["message"];
            // alert(result["message"]);
        }
    };

    return(
        <form onSubmit = {handleSubmit}>

            <h3 className="text-center mb-4" > {translations[language].loginInfo} </h3>

            <div id="login-error" className="text-center text-danger mb-2"></div>

            <div className="form-group mb-3">
                <input
                    required
                    className="form-control form-input text-center"
                    type = "email"
                    placeholder = {translations[language].emailPlaceholder}
                    value = {email}
                    onChange = {(e) => setEmail(e.target.value)}
                />
            </div>


            <div className="form-group mb-4">
                <input
                    required
                    className="form-control form-input text-center"
                    type = "password"
                    placeholder = {translations[language].passwordPlaceholder}
                    value = {password}
                    onChange = {(e) => setPassword(e.target.value)}
                />
            </div>

            <div>
                <button className="btn btn-primary form-action-button" type = "submit">{translations[language].loginButton}</button>
                <button className="btn btn-danger form-action-button ms-2" type = "button" onClick = {onClose}>{translations[language].cancelButton}</button>
            </div>

        </form>
    );

}

export default LoginForm;
